"use strict";

document.addEventListener( 'DOMContentLoaded', function () {

    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * hamburger
    // *
    // *

    const hamburger = document.querySelector(".hamburger");
    const navigation =  document.querySelector(".nav");
    const html = document.querySelector("html");
    const body = document.querySelector("body");

    hamburger.addEventListener("click", function () {
        navigation.classList.toggle("nav__show");
        
        let expanded = this.getAttribute('aria-expanded');

        if (expanded === 'false') {
            this.setAttribute('aria-expanded', 'true')
            this.classList.add('open');
            html.classList.add("freeze"); 
            body.classList.add("freeze"); 
        } else {
            this.setAttribute('aria-expanded', 'false')
            this.classList.remove('open');
            html.classList.remove("freeze"); 
            body.classList.remove("freeze"); 
        }
    });

    hamburger.addEventListener("keydown", function (event) {
        if (event.keyCode === 13 || event.keyCode === 32) {

            event.preventDefault();

            navigation.classList.toggle("nav__show");

            let expanded = this.getAttribute('aria-expanded');

            if (expanded === 'false') {
                this.setAttribute('aria-expanded', 'true')
                this.classList.add('open');
                html.classList.add("freeze"); 
                body.classList.add("freeze"); 
            } else {
                this.setAttribute('aria-expanded', 'false')
                this.classList.remove('open');
                html.classList.remove("freeze"); 
                body.classList.remove("freeze"); 
            } 
        }
    });

    document.addEventListener('keydown', function(event){
        if(event.key === "Escape"){
            event.preventDefault();

            navigation.classList.toggle("nav__show");

            let expanded = this.getAttribute('aria-expanded');

            if (expanded == 'false') {
                this.setAttribute('aria-expanded', 'true')
            } else {
                this.setAttribute('aria-expanded', 'false')
            }
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('splideHeroSlider');
    
    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type            : 'fade',
                rewind          : true,
                autoplay        : true,
                arrows          : false,
                pagination      : false,
                lazyLoad        : 'nearby'
            }).mount();
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide imageSlider
    // *
    // *

    const textImageSlider = document.getElementsByClassName('splideTextImageSlider');
    
    if (textImageSlider !== null) {
        for (let i = 0; i < textImageSlider.length; i++) {
            const splide = new Splide(textImageSlider[i], {
                type            : 'fade',
                rewind          : true,
                autoplay        : true,
                arrows          : false,
                pagination      : true,
                lazyLoad        : 'nearby'
            });

            splide.on( 'pagination:mounted', function ( data ) {
                data.list.classList.add( 'splide__pagination--custom' );
                
                data.items.forEach( function ( item ) {
                    item.button.textContent = String( item.page + 1 );
                });
            });

            splide.mount();
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide video overlay
    // *
    // *

    const imageOverlaySlider = document.getElementsByClassName('splideVideoOverlay');
    
    if (imageOverlaySlider !== null) {
        for (let i = 0; i < imageOverlaySlider.length; i++) {
            const splide = new Splide(imageOverlaySlider[i], {
                type            : 'fade',
                rewind          : true,
                autoplay        : true,
                arrows          : false,
                pagination      : true,
                lazyLoad        : 'nearby'
            });

            splide.on( 'pagination:mounted', function ( data ) {
                data.list.classList.add( 'splide__pagination--custom' );
                
                data.items.forEach( function ( item ) {
                    item.button.textContent = String( item.page + 1 );
                });
            });

            splide.mount();
        }
    }

    

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    // onclick scroll to top
    document.querySelector(".js-scrolltop").onclick = function(e){
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    const scrolltotop  = document.querySelector(".js-scrolltop");

    scrolltotop.addEventListener("keydown", function (event) {
        if (event.keyCode === 13 || event.keyCode === 32) {

            event.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }   
    });

    // show and hide scrollToTop btn
    document.addEventListener('scroll', function(e) {
        if (window.scrollY > 300) {
            document.querySelector(".js-scrolltop").classList.add("show");
        } else {
            document.querySelector(".js-scrolltop").classList.remove("show");
        }
    });


    
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchors = document.querySelectorAll(".js-scrollTo");

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
    
        let href = this.getAttribute("href").split("#");
        let newAnchor = "#my" + href[1]
        let offsetTop = document.querySelector(newAnchor).offsetTop - 60;

        if (window.innerWidth > 1200) {
            offsetTop = offsetTop - 80
        }

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion open every tab
    // *
    // *

    const title = document.querySelectorAll(".js-accordion-title");
    if (title !== null) {
        for (var i=0; i < title.length; i++) {
            title[i].onclick = function(e) {
                this.classList.toggle("open");
                this.nextElementSibling.classList.toggle("open");

                let expanded = this.getAttribute('aria-expanded');
        
                if (expanded == 'false') {
                    this.setAttribute('aria-expanded', 'true')
                } else {
                    this.setAttribute('aria-expanded', 'false')
                }
            }
            title[i].addEventListener("keydown", function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
        
                    event.preventDefault();
        
                    this.classList.toggle("open");
                    this.nextElementSibling.classList.toggle("open");
        
                    let expanded = this.getAttribute('aria-expanded');
        
                    if (expanded == 'false') {
                        this.setAttribute('aria-expanded', 'true')
                    } else {
                        this.setAttribute('aria-expanded', 'false')
                    }
                }
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpen = document.querySelector(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");
    
    /* onclick show modal window */
    if (modalOpen !== null) {
        modalOpen.onclick = function() {
            modalWindow.style.display = "block";
            modalClose.focus();
        }
    }
    
    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = function() {
            modalWindow.style.display = "none";
        }
    }
    
    /* clicks anywhere outside close modal window */
    window.onclick = function(event) {
        if (event.target == modalWindow) {
            modalWindow.style.display = "none";
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *
    function externalLinks() {
        for(let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];
            let jsTest = currentLink.toString().includes("javascript");
            
            if (jsTest == false){
                // check if link has same hostname. if not add target blank.
                currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
            }
        }
    };
    externalLinks();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * aos
    // *
    // *

    AOS.init({
        offset: 200,
        duration: 700,
        delay: 100,
        disable: 'mobile',
        easing: 'ease-out-back'
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * lightbox plugin
    // *
    // *

    new SimpleLightbox({
        elements            : 'a.lightBoxImageLink',
        closeBtnCaption     : 'Schließen',
        nextBtnCaption      : 'Nächstes',
        prevBtnCaption      : 'Vorheriges'
    });

    new SimpleLightbox({
        elements            : 'a.lightBoxVideoLink',
        closeBtnCaption     : 'Schließen',
        nextBtnCaption      : 'Nächstes',
        prevBtnCaption      : 'Vorheriges'
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mobile menu
    // *
    // *

    if (window.innerWidth < 1200) {
        const nav = document.querySelectorAll(".js-subnav");
        
        if (nav !== null) {
            for (var i=0; i < nav.length; i++) {
                nav[i].onclick = function(e) {
                    this.parentNode.parentNode.classList.toggle("open");
                }
            }
        }

        const links = document.querySelectorAll(".nav a");
        const hamburger = document.querySelector(".hamburger");
        const navigation =  document.querySelector(".nav");

        if (links !== null) {
            for (var i=0; i < links.length; i++) {
                links[i].onclick = function(e) {
                    navigation.classList.remove("nav__show");
                    hamburger.classList.remove("open");
                }
            }
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * search
    // *
    // *
    if (window.innerWidth > 1200) {
        const search = document.querySelector(".searchForm__icon.js-search-button");
        const close = document.querySelector(".searchForm__close.js-search-button");
        const searchForm = document.querySelector(".searchForm__input");
        const nav = document.querySelector(".nav__inner > ul");

        search.addEventListener("click", function () {
            search.classList.toggle("active");
            searchForm.classList.toggle("active");
            nav.classList.toggle("active");
            close.classList.toggle("active");
        });

        close.addEventListener("click", function () {
            search.classList.toggle("active");
            searchForm.classList.toggle("active");
            nav.classList.toggle("active");
            close.classList.toggle("active");
        });
    }
    // $(".js-search-button").click(function () {
    //     var $input = $(".js-search-input"),
    //         $searchForm = $(".js-search-form");

    //     $(".js-search-input").focus();

    //     if ($searchForm.hasClass("active")) {
    //         if ($input.val().length) {
    //             $searchForm.submit();
    //         } else {
    //             $searchForm.removeClass("active");
    //             $(".js-nav").removeClass("hidden");
    //             $(".js-tel").removeClass("hidden");
    //             $(".js-logo").removeClass("hidden");
    //         }
    //     } else {
    //         $searchForm.addClass("active");
    //         $(".js-nav").addClass("hidden");
    //         $(".js-tel").addClass("hidden");
    //         $(".js-logo").addClass("hidden");
    //     }
    // });

});


// * * * * * * * * * * * * * * * * * * * * * * * * *
// * hash link jump to content
// *
// *

window.addEventListener('load', function () {
    let getHash = window.location.hash;
    let elementExists = document.getElementById("my" + getHash.slice(1));

    if (getHash !== null && elementExists !== null) {
        let name = "#my" + getHash.slice(1);
        let offsetTop = document.querySelector(name).offsetTop - 60;
        
        if (window.innerWidth > 1200) {
            offsetTop = offsetTop - 80
        }

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }
}, false);